import { Component, OnInit } from '@angular/core';
import { NgFlowchartStepComponent } from '../../../../../../projects/ng-flowchart/src/lib/ng-flowchart-step/ng-flowchart-step.component';

export type MyForm = {
  input1: string;
};

@Component({
  selector: 'app-form-step4',
  templateUrl: './form-step4.component.html',
  styleUrls: ['./form-step4.component.scss'],
})
export class FormStep4Component
  extends NgFlowchartStepComponent<MyForm>
  implements OnInit
{
  constructor() {
    super();
  }

  override ngOnInit(): void {
    console.log(this.data);
  }
}
